"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = exports.isFirefox = exports.isSafari = exports.isEdge = exports.isChrome = exports.isPCDevice = exports.isMac = exports.isKindle = exports.isMobileDevice = exports.isIE = exports.isAndroid = exports.isIos = void 0;
var utils_1 = require("../../utils/utils");
exports.isIos = utils_1.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent));
});
exports.isAndroid = utils_1.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /android/i.test(navigator.userAgent));
});
exports.isIE = utils_1.makeSsrSafe(function () {
    return Boolean(/MSIE|Trident/i.test(window.navigator.userAgent));
});
exports.isMobileDevice = utils_1.makeSsrSafe(function () {
    return Boolean(navigator.userAgent &&
        /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Silk/i.test(navigator.userAgent));
});
exports.isKindle = utils_1.makeSsrSafe(function () {
    return Boolean(/Silk/i.test(window.navigator.userAgent));
});
exports.isMac = utils_1.makeSsrSafe(function () {
    return Boolean(/Macintosh/i.test(window.navigator.userAgent));
});
exports.isPCDevice = utils_1.makeSsrSafe(function () {
    return Boolean(!exports.isAndroid() && !exports.isIos() && !exports.isKindle() && !exports.isMac());
});
exports.isChrome = utils_1.makeSsrSafe(function () {
    return Boolean(/Chrome/i.test(window.navigator.userAgent));
});
exports.isEdge = utils_1.makeSsrSafe(function () {
    return Boolean(/(?=.*AppleWebKit)(?=.*Safari)(?=.*Edg)/i.test(window.navigator.userAgent));
});
exports.isSafari = utils_1.makeSsrSafe(function () {
    return Boolean(exports.isMac && !exports.isMobileDevice && !exports.isChrome && /Safari/i.test(window.navigator.userAgent));
});
exports.isFirefox = utils_1.makeSsrSafe(function () {
    return Boolean(/Firefox/i.test(window.navigator.userAgent) &&
        "MozAppearance" in document.documentElement.style);
});
exports.isTouch = utils_1.makeSsrSafe(function () {
    return Boolean("ontouchstart" in document.documentElement);
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/UserAgent.js
// module id = 210
// module chunks = 8